import React from "react";
import Layout from "./src/components/template/Default";

export const wrapPageElement = ({ element }) => {
  return <Layout>{element}</Layout>;
};

const transitionDelay = 1300;

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  if (location.action === "PUSH") {
    window.setTimeout(() => window.scrollTo(0, 0), transitionDelay);
  } else {
    const savedPosition = getSavedScrollPosition(location);
    window.setTimeout(() => window.scrollTo(...(savedPosition || [0, 0])), transitionDelay);
  }
  return false;
};
